// extracted by mini-css-extract-plugin
export default {"subscription":"SubscriptionBreakdown_subscription__C3GSL"};